import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          <code>tobbe303.se</code>
        </p>
      </header>
    </div>
  );
}

export default App;
